import { isEqual, isUndefined } from 'lodash-es';
import {
  useEffect,
  useState,
  KeyboardEvent as ReactKeyboardEvent,
} from 'react';

import type { ToolbarInteractionModes } from '../types/toolbar-interaction-modes.js';
import { A11yToolbarTabIndex } from '../types/toolbar.js';
import {
  ArrowDirection,
  handleControls,
} from '../utils/a11yToolbarControls.js';

/**
 * Add A11y controls: arrow left and right modifies dynamically toolbar button tabIndex
 * @internal
 */
export function useA11yToolbarControls(
  initialA11yToolbarTabIndexContext: A11yToolbarTabIndex[],
) {
  const [keyEvent, setKeyEvent] = useState<ReactKeyboardEvent>();
  const [a11yControlsValue, setA11yControlsValue] = useState<
    A11yToolbarTabIndex[]
  >(initialA11yToolbarTabIndexContext);

  // FYI:https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
  const [prevA11yToolbar, setPrevA11yToolbarItems] = useState(
    initialA11yToolbarTabIndexContext,
  );

  if (!isEqual(prevA11yToolbar, initialA11yToolbarTabIndexContext)) {
    setPrevA11yToolbarItems(initialA11yToolbarTabIndexContext);
    setA11yControlsValue(initialA11yToolbarTabIndexContext);
  }

  useEffect(() => {
    if (!isUndefined(keyEvent)) {
      setA11yControlsValue((prevControls) =>
        handleControls(keyEvent.code as ArrowDirection, prevControls),
      );
    }
  }, [keyEvent]);

  const setActiveControl = (type: ToolbarInteractionModes) => {
    setA11yControlsValue((prevControls) =>
      prevControls.map((control) => {
        const key = Object.keys(control)[0];
        return { [key]: key === type ? 0 : -1 };
      }),
    );
  };

  return { a11yControlsValue, setKeyEvent, setActiveControl };
}
